import { useState } from 'react'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { toast } from '@dd3tech/wiggui/Toast'
import { postResendEmailVerification } from '../../../services/auth.services'
import { useModalActiveAccountStore } from '../../../store'

export const useModalActiveAccount = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useSession()

  const modalActiveAccount = useModalActiveAccountStore(
    (state) => state.modalActiveAccount
  )
  const setModalActiveAccount = useModalActiveAccountStore(
    (state) => state.setModalActiveAccount
  )

  const handleResendEmailVerification = async () => {
    if (!profile?.email) {
      toast({
        type: 'error',
        title:
          'Por favor actualiza tu correo electrónico para poder reenviar el correo de activación.'
      })
      return
    }

    setIsLoading(true)
    const { isSuccess } = await postResendEmailVerification({
      email: profile?.email
    })
    setIsLoading(false)

    if (isSuccess) {
      modalActiveAccount?.onSuccess?.()
      toast({
        type: 'success',
        title: 'Correo de activación reenviado'
      })
      return
    }
    toast({
      type: 'error',
      title: 'No se pudo reenviar el correo de activación'
    })
  }

  const onClose = () => {
    setModalActiveAccount({
      isOpen: false
    })
  }
  return {
    handleResendEmailVerification,
    onClose,
    isLoading
  }
}
